import { useFiltersContext } from '@openx/components-filters/lib/context/FiltersContext.tsx';
import { TopBar } from '@openx/components-table/ChipFilters/TopBar.tsx';
import { useTranslation } from 'react-i18next';
import type { CuratedDealBuyerDiscountsListFilters } from './types.ts';

export const CuratedDealBuyerDiscountsTopBar = () => {
  const { onFiltersChange, criteria } = useFiltersContext<CuratedDealBuyerDiscountsListFilters>();
  const { t } = useTranslation();

  return (
    <TopBar
      filters={criteria.filters as CuratedDealBuyerDiscountsListFilters}
      minLength={1}
      onChange={onFiltersChange}
      searchText={t('Search Name, ID or Received Seat ID')}
      useFiltersV2
    />
  );
};
